module.exports = __webpack_public_path__ + "img/vendas.269a242e.jpg";